module.exports = {
  App: {
    Agreement: 'Please read and agree to the User Agreement'
  }
}
